var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCropicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 22.4H25.6V10.496C25.6 9.95811 25.4941 9.42548 25.2882 8.92853C25.0824 8.43158 24.7807 7.98004 24.4003 7.59969C24.02 7.21934 23.5684 6.91763 23.0715 6.71179C22.5745 6.50595 22.0419 6.4 21.504 6.4H9.6V1.6C9.6 1.17565 9.43143 0.768687 9.13137 0.468629C8.83131 0.168571 8.42435 0 8 0C7.57565 0 7.16869 0.168571 6.86863 0.468629C6.56857 0.768687 6.4 1.17565 6.4 1.6V6.4H1.6C1.17565 6.4 0.768687 6.56857 0.468629 6.86863C0.168571 7.16869 0 7.57565 0 8C0 8.42435 0.168571 8.83131 0.468629 9.13137C0.768687 9.43143 1.17565 9.6 1.6 9.6H6.4V21.504C6.4 22.5903 6.83154 23.6322 7.59969 24.4003C8.36784 25.1685 9.40967 25.6 10.496 25.6H22.4V30.4C22.4 30.8243 22.5686 31.2313 22.8686 31.5314C23.1687 31.8314 23.5757 32 24 32C24.4243 32 24.8313 31.8314 25.1314 31.5314C25.4314 31.2313 25.6 30.8243 25.6 30.4V25.6H30.4C30.8243 25.6 31.2313 25.4314 31.5314 25.1314C31.8314 24.8313 32 24.4243 32 24C32 23.5757 31.8314 23.1687 31.5314 22.8686C31.2313 22.5686 30.8243 22.4 30.4 22.4ZM10.496 22.4C10.2584 22.4 10.0305 22.3056 9.86243 22.1376C9.6944 21.9695 9.6 21.7416 9.6 21.504V9.6H21.504C21.7416 9.6 21.9695 9.6944 22.1376 9.86243C22.3056 10.0305 22.4 10.2584 22.4 10.496V22.4H10.496Z",
    fill: "#FFFBFB",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropicon);
export default __webpack_public_path__ + "static/media/crop icon.1c3233c8941cd63f30624444d21eff8e.svg";
export { ForwardRef as ReactComponent };